import { render, staticRenderFns } from "./parameter_manage.vue?vue&type=template&id=523951d8"
import script from "./parameter_manage.vue?vue&type=script&lang=js"
export * from "./parameter_manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports